<template>
    <div class="container">
        <div class="logo">
            <img src="../../assets/images/Logo.png" alt="监控平台" />
            <div class="name">监控平台</div>
        </div>
        <el-dropdown szie="medium">
            <div class="user">
                <img v-if="user && user.avatar" :src="imgUrl + user.avatar" />
                <img v-else src="../../assets/images/default-avatar.png" />
                <span>{{user.name}}</span>
            </div>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                    <el-button style="padding: 0 5px;" size="medium" type="text" @click="handlePasswordFormShow">更新密码
                    </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                    <el-button style="padding: 0 5px;" size="medium" type="text" @click="logout">退 出
                    </el-button>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <el-dialog title="更新密码" :visible.sync="passwordFormVisible" width="30%" :modal="false"
            @closed="handlePasswordFormClosed">
            <div class="event-dialog-content">
                <el-form :model="passwordForm">
                    <el-form-item label="旧密码" label-width="80px">
                        <el-input v-model="passwordForm.old" placeholder="请填写旧密码" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" label-width="80px">
                        <el-input v-model="passwordForm.new" placeholder="请填写新密码" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="passwordFormVisible = false">取 消</el-button>
                <el-button style="margin-left: 20px;" type="primary" @click="handleSave">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Core from 'core';
import { mapState } from 'vuex';
import * as types from '../../store/mutation-types';

export default {
    components: {},
    props: {},
    data() {
        return {
            imgUrl: Core.Const.NET.IMG_URL,
            passwordForm: {
                old: '',
                new: ''
            },
            passwordFormVisible: false
        };
    },
    computed: {
        ...mapState(['user'])
    },
    mounted() {},
    methods: {
        logout() {
            Core.Data.setToken('');
            this.$router.replace({
                path: '/login'
            });
        },
        handlePasswordFormShow() {
            this.passwordFormVisible = true;
        },
        handlePasswordFormClose() {
            this.passwordFormVisible = false;
        },
        handlePasswordFormClosed() {
            Core.Util.emptyObject(this.passwordForm);
        },
        handleSave() {
            Core.Api.User.passwordUpdate(
                this.passwordForm.old,
                this.passwordForm.new
            ).then((res) => {
                this.$message({
                    type: 'success',
                    message: '更新成功!'
                });
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.container {
    width: 100vw;
    height: 50px;
    box-sizing: border-box;
    @include flex(row, space-between, center);
    .logo {
        @include ftb;
        @include no-select;
        cursor: pointer;
        width: 180px;
        padding-left: 20px;
        img {
            width: 32.25px;
            height: 21.5px;
            margin-right: 6px;
        }
        .name {
            font-weight: 700;
            font-size: 16px;
        }
    }
    .user {
        @include ftb;
        @include no-select;
        cursor: pointer;
        margin-right: 20px;
        img {
            width: 30px;
            height: 30px;
            margin-right: 10px;
            border-radius: 50%;
        }
    }
}
</style>